export * from "./profile.component";
export * from "./profile.module";


// WEBPACK FOOTER //
// ./src/app/profile/index.ts